import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      Deal: "Deal",
      "Date of initial investment": "Date of initial investment",
      TotalCompaniesStatus: "Total {{status}} companies",
      "Total In portfolio companies": "Total in portfolio companies",
      "Total Exited companies": "Total exited companies",
      "Cost of investment": "Cost of investment",
      "Acquisition sold cost": "Acquisition sold cost",
      "Dividends & interests": "Dividends & interests",
      "Capital gains and losses": "Capital gains and losses",
      "Total net proceeds": "Total net proceeds",
      "FMV + proceeds": "FMV + proceeds",
      "Gross multiple": "Gross multiple",
      "Remaining acquisition cost": "Remaining acquisition cost",
      "Accrued interest": "Accrued interest",
      "Fair market value": "Fair market value",
      "Gross IRR": "Gross IRR",
      "Instrument type": "Instrument type",
      "% Ownership (FD)": "% Ownership (FD)",
      "# shares/bonds": "# shares/bonds",
      "Current cost of investment": "Current cost of investment",
      TotalTransactionsRoundType: "Total {{roundType}} transactions",
      Equity: "Equity",
      "Conv. Bound": "Conv. Bound",
      "Valuation justification": "Valuation justification",
      "The company": "The company",
      "Deal overview": "Deal overview",
      "Key terms at entry": "Key terms at entry",
      "Initial investment date": "Initial investment date",
      "Type of investment": "Type of investment",
      "Ring team": "Ring team",
      "Ring role": "Ring role",
      "Financing round": "Financing round",
      "Co-investors": "Co-investors",
      "Entry multiple": "Entry multiple",
      "Entry equity valuation (pre)": "Entry equity valuation (pre)",
      "Expected exit multiple": "Expected exit multiple",
      "Expected type of exit": "Expected type of exit",
      "Deal Overview as of": "Deal Overview as of",
      Invested: "Invested",
      "Realized value": "Realized value",
      "Unrealized value": "Unrealized value",
      "Total value": "Total value",
      "Enterprise value": "Enterprise value",
      "Valuation method": "Valuation method",
      "Overall multiple": "Overall multiple",
      "Capitalization table (non fully-diluted)":
        "Capitalization table (non fully-diluted)",
      "Fully diluted information": "Fully diluted information",
      "Ring - other funds": "Ring - other funds",
      "Founders + Mgt.": "Founders + Mgt.",
      "No captable data available": "No captable data available",
      "Unknown Fund": "Unknown Fund",
      Funds: "Funds",
      "BA and others": "BA and others",
      "Sectorial Multiples": "Sectorial Multiples",
      "Exit price": "Exit price",
      "Recent investment": "Recent investment",
      "Recent offer": "Recent offer",
      "Last round": "Last round",
      Cost: "Cost",
      Growth: "Growth",
      Venture: "Venture",
      "Pre-seed": "Pre-seed",
      Seed: "Seed",
      Other: "Other",
      Minority: "Minority",
      Majority: "Majority",
      Lead: "Lead",
      Follow: "Follow",
      "Investment rationale": "Investment rationale",
      Risks: "Risks",
      "Value creation plan": "Value creation plan",
      Financials: "Financials",
      Revenue: "Revenue",
      "Gross margin": "Gross margin",
      Ebitda: "EBITDA",
      Cash: "Cash",
      Employees: "Employees",
      "Year end": "Year end",
    },
  },
  fr: {
    translation: {
      Deal: "Investissement",
      "Date of initial investment": "Date de l'investissement initial",
      TotalCompaniesStatus: "Total des sociétés {{status}}",
      "Total In portfolio companies": "Total des sociétés en portefeuille",
      "Total Exited companies": "Total des sociétés cédées",
      "Cost of investment": "Coût d'acquisition",
      "Acquisition sold cost": "Coût d'acquisition cédé",
      "Dividends & interests": "Dividendes & intérêts",
      "Capital gains and losses": "Plus-values et moins-values",
      "Total net proceeds": "Produit net total",
      "FMV + proceeds": "Valorisation + produits",
      "Gross multiple": "Multiple brut",
      "Remaining acquisition cost": "Coût d'acquisition résiduel",
      "Accrued interest": "Intérêts courus",
      "Fair market value": "Valorisation",
      "Gross IRR": "TRI Brut",
      "Instrument type": "Instrument",
      "% Ownership (FD)": "% de détention (FD)",
      "# shares/bonds": "Nombre d'actions/obligations",
      "Current cost of investment": "Coût actuel de l'investissement",
      TotalTransactionsRoundType: "Total des transactions {{roundType}}",
      Equity: "Action",
      "Conv. Bound": "Oblig. conv.",
      "Valuation justification": "Justification de la valorisation",
      "The company": "L'entreprise",
      "Deal overview": "Résumé de l'opération",
      "Key terms at entry": "Conditions clés à l'entrée",
      "Initial investment date": "Date d'investissement initial",
      "Type of investment": "Type d'investissement",
      "Ring team": "Équipe Ring",
      "Ring role": "Rôle de Ring",
      "Financing round": "Tour de financement",
      "Co-investors": "Co-investisseurs",
      "Entry multiple": "Multiple d'entrée",
      "Entry equity valuation (pre)": "Valorisation d'équité à l'entrée (pré)",
      "Expected exit multiple": "Multiple de sortie attendu",
      "Expected type of exit": "Type de sortie attendu",
      "Deal Overview as of": "Résumé de l'opération au",
      Invested: "Investissement",
      "Realized value": "Valeur réalisée",
      "Unrealized value": "Valeur non-réalisée",
      "Total value": "Valeur totale",
      "Enterprise value": "Valeur d'entreprise",
      "Valuation method": "Méthode de valorisation",
      "Overall multiple": "Multiple",
      "Capitalization table (non fully-diluted)":
        "Table de capitalisation avant dilution",
      "Fully diluted information": "Table diluée",
      "Ring - other funds": "Ring - autres fonds",
      "Founders + Mgt.": "Fondateurs + Mgt.",
      "No captable data available": "Aucune donnée de captable disponible",
      "Unknown Fund": "Fonds inconnu",
      Funds: "Fonds",
      "BA and others": "BA et autres",
      "Sectorial Multiples": "Multiples sectoriels",
      "Exit price": "Prix de sortie",
      "Recent investment": "Investissement récent",
      "Recent offer": "Offre récente",
      "Last round": "Dernier tour",
      Cost: "Coût",
      Growth: "Développement",
      Venture: "Venture",
      "Pre-seed": "Pre-origination",
      Seed: "Origination",
      Other: "Autre",
      Minority: "Minoritaire",
      Majority: "Majoritaire",
      Lead: "Lead",
      Follow: "Suiveur",
      "Investment rationale": "Thèse d'investissement",
      Risks: "Risques",
      "Value creation plan": "Plan de création de valeur",
      Financials: "Performances financières",
      Revenue: "Chiffre d'affaires",
      "Gross margin": "Marge brute",
      Ebitda: "Ebitda",
      Cash: "Trésorerie",
      Employees: "Employés",
      "Year end": "Fin d'année",
      "Full year": "Année complète",
      Month: "Mois",
      Quarter: "Trimestre",
      Forecast: "Prévision",
      Budget: "Budget",
      Unknown: "Inconnu",
      "Closing date is end of": "La clôture est fin ",
      January: "janvier",
      February: "février",
      March: "mars",
      April: "avril",
      May: "mai",
      June: "juin",
      July: "juillet",
      August: "août",
      September: "septembre",
      October: "octobre",
      November: "novembre",
      December: "décembre",
      End: "Fin",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

const i18nfr = i18n.createInstance();
i18nfr.init({
  resources,
  lng: "fr",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export { i18nfr };

export default i18n;
